import React, {Component} from 'react';
import {connect} from 'react-redux';
import FilterSelection from "./filterSelection";
import PropTypes from "prop-types";
import {CABINET_WIZARD_BUTTONS, COUNTERTOP_WIZARD_BUTTONS} from "../../../kvComponent/core/constants";
import {
  setActiveNavigationFilter,
  setCountertopWizard,
  setActiveNavigationFilterStepIndex,
  setNavigationViewType
} from "../../../../actions/navigationFunctions";
import {wizardAllButton} from "../../../kvComponent/core/constants";
import {setSelectedFilters} from "../../../../actions/actionFunctions";
import {replaceFilterArrayValue, toggleFilterArrayValue} from "./filterSwitchers";
import {getBvGroupFilterValues} from "../../../../api/server-api";
import {setAvailableFilterValues} from "../../../../actions/filtersFunctions";
import {s3FilterImagePath} from "../../../../misc/utils";
import {getAllFilterGroupValuesFromGroup} from "../../../../misc/helpers";

class NavigationFilters extends Component {

  static propTypes = {
    isMobile: PropTypes.bool,
    activePart: PropTypes.object.isRequired,
    onItemClick: PropTypes.func.isRequired,
    refreshCB: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      availableFilterValues: [],
      isLoading: false,
      filterGroup: {}
    };
  }

  componentDidMount() {
    this.setAvailableFiltersValues(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if ((nextProps.activePart && this.props.activePart && nextProps.activePart.partName !== this.props.activePart.partName)
      || (nextProps.activeNavigationFilter !== this.props.activeNavigationFilter)) {
      this.setAvailableFiltersValues(nextProps);
    }
    this.resetFilters(nextProps);
  }

  componentWillUnmount() {
    this.removeNavigationFiltersAndSetCommonView();
  }

  resetFilters(nextProps) {
    if ((nextProps.activeNavigationFilter !== this.props.activeNavigationFilter)
      && (nextProps.activeNavigationFilter === COUNTERTOP_WIZARD_BUTTONS[1].buttonId)
      && nextProps.selectedFilters.length
    ) {
      this.props.setSelectedFilters([]); // reset filters on color step
    }
  }

  getFilterGroupNameByButtonId(nextProps) {
    let activeButton = null;
    switch (nextProps.activePart.partId) {
      case "top_cabinet":
      case "bottom_cabinet":
        activeButton = CABINET_WIZARD_BUTTONS.find(button => button.buttonId === nextProps.activeNavigationFilter);
        break;
      case "countertop":
      case "center_island_countertop":
        activeButton = COUNTERTOP_WIZARD_BUTTONS.find(button => button.buttonId === nextProps.activeNavigationFilter);
        break;
      default:
        break;
    }
    return activeButton ? activeButton.filtersGroupName : "";
  }

  setAvailableFiltersValues(nextProps = this.props) {
    const filterGroupName = this.getFilterGroupNameByButtonId(nextProps);
    const filterGroup = nextProps.filterGroups.find(group => group.name === filterGroupName);
    if (filterGroup) {
      const selectedFilters = (filterGroup.name === COUNTERTOP_WIZARD_BUTTONS[2].filtersGroupName)
        ? nextProps.selectedFilters : []; // filter by selected filters only on 2nd(Material step)
      const availableFilterValues = FilterSelection.getAvailableFilterValues(
        nextProps.filterGroups, filterGroupName, nextProps.activePart, this.props.fabricatorData, selectedFilters
      );
      // console.log("availableFilterValues::", availableFilterValues);
      const reorderedFilterValues = this.reorderFilterItems(nextProps, availableFilterValues);
      const countertopMaterialOrColor = (
        nextProps.activeNavigationFilter === COUNTERTOP_WIZARD_BUTTONS[1].buttonId
        || nextProps.activeNavigationFilter === COUNTERTOP_WIZARD_BUTTONS[2].buttonId
      );
      if (countertopMaterialOrColor ) {
        if (this.props.availableFilterValues[filterGroup.id]) {
          this.setToStateFilterValues(["All", ...this.props.availableFilterValues[filterGroup.id]], filterGroup);
        } else {
          this.setState({
            isLoading: true
          });
          getBvGroupFilterValues(nextProps.activePart.dbName || nextProps.activePart.partName, filterGroup.id)
            .then((response) => {
              this.props.setAvailableFilterValues({
                [filterGroup.id]: response.data
              });
              this.setToStateFilterValues(["All", ...response.data], filterGroup);
            })
        }
      } else {
        this.setToStateFilterValues(reorderedFilterValues, filterGroup);
      }
    }
  }

  setToStateFilterValues = (availableFilterValues, filterGroup) => {
    this.setState({
      isLoading: false,
      availableFilterValues,
      filterGroup
    })
  };

  setParentFilterValues = (filterValues) => {
    const nextProps = this.props;
    const filterGroupName = this.getFilterGroupNameByButtonId(nextProps);
    const filterGroup = nextProps.filterGroups.find(group => group.name === filterGroupName);
    const selectedFilters = (filterGroup.name === COUNTERTOP_WIZARD_BUTTONS[2].filtersGroupName)
      ? nextProps.selectedFilters : []; // filter by selected filters only on 2nd(Material step)

    let availableFilterValues = [];
    if (selectedFilters.length) {
      const colorFilterName = COUNTERTOP_WIZARD_BUTTONS[1].filtersGroupName;
      const colorFilterGroup = nextProps.filterGroups.find(group => {
        return group.name === colorFilterName
      });
      if (colorFilterGroup) {
        const selectedColorFilter = selectedFilters.find(filterG => filterG.filterGroupId === colorFilterGroup.id);
        const selectedColorValue = selectedColorFilter && selectedColorFilter.filterId;
        if (selectedColorValue || selectedColorValue === 0) {
          filterValues.forEach(filterValue => {
            if (nextProps.activePart.features.some(feature => {
              return feature.dbFeature
                && feature.dbFeature.filterValueIDs[filterGroup.id]
                && feature.dbFeature.filterValueIDs[filterGroup.id].includes(filterValue)
                && feature.dbFeature.filterValueIDs[colorFilterGroup.id]
                && feature.dbFeature.filterValueIDs[colorFilterGroup.id].includes(selectedColorValue)
            })) {
              availableFilterValues.push(filterValue)
            }
          })
        } else {
          availableFilterValues = filterValues;
        }
      } else {
        availableFilterValues = filterValues;
      }
    } else {
      availableFilterValues = filterValues;
    }
    const reorderedFilterValues = this.reorderFilterItems(this.props, availableFilterValues);
    this.setState({
      availableFilterValues: reorderedFilterValues
    })
  };

  reorderFilterItems = (nextProps, availableFilterValues) => {
    const currentActiveFilters = nextProps.activePart.activeFeature
      ? nextProps.activePart.activeFeature.dbFeature.filterValueIDs
      : {};
    // console.log("currentActiveFilters", currentActiveFilters);
    return availableFilterValues.sort((a,b) => {
      const activeA = this.filterValueIsActive(currentActiveFilters, a);
      const activeB = this.filterValueIsActive(currentActiveFilters, b);
      return activeA !== activeB ? activeA < activeB ? -1 : 1 : 0;
    })
  };

  getFeatureBodyItemThumbnail = (currentFilterValue) => { // we have the logic with additionalImages in the FeatureWizardBody component
    const additionalImages = currentFilterValue.additionalImages;
    if (Array.isArray(additionalImages) && additionalImages.length) {
      return additionalImages[0].imageUrl
    }
    return s3FilterImagePath(currentFilterValue.icon);
  };

  filterValueIsActive = (currentActiveFilters, currentFilterValue) => {
    const activeNavigationFilter = this.props.activeNavigationFilter;
    const countertopMaterialOrColor = (
      activeNavigationFilter === COUNTERTOP_WIZARD_BUTTONS[1].buttonId
      || activeNavigationFilter === COUNTERTOP_WIZARD_BUTTONS[2].buttonId
    );
    if (countertopMaterialOrColor) {
      return false
    }
    if (activeNavigationFilter === "inlay_type" && this.state.filterGroup && this.state.filterGroup.values) {
      const modulePartJoined = this.props.moduleContextMenuModule + "_" + this.props.moduleContextMenuModulePart; //"2_3"
      for (let i = 0; i <= this.props.activePart.inlayTypes.length - 1; i++) {
        const inlayTypeObject = this.props.activePart.inlayTypes[i];
        const existingMJoined = inlayTypeObject.moduleParts.find(mJoined => mJoined === modulePartJoined);
        if (existingMJoined) {  // not default!
          const fValue = this.state.filterGroup.values.find(val => val.value === inlayTypeObject.name);
          return fValue.id === currentFilterValue.id
        }
      }
      return currentFilterValue.value === this.props.activePart.defaultInlayType
    // } else if ((activeNavigationFilter === COUNTERTOP_WIZARD_BUTTONS[2].buttonId)
    //   || (activeNavigationFilter === COUNTERTOP_WIZARD_BUTTONS[3].buttonId)) {
    //   // return this.props.counterTopWizard[activeNavigationFilter] === currentFilterValue.id
    //   const selectedFilter = this.props.selectedFilters.find(selectedF => {
    //     return selectedF.filterGroupId === this.state.filterGroup.id
    //   });
    //   return (currentFilterValue.id === "All")
    //     ? !selectedFilter
    //     : selectedFilter && (selectedFilter.filterId === currentFilterValue.id)
    }

    return this.state.filterGroup && currentActiveFilters[this.state.filterGroup.id]
      && currentActiveFilters[this.state.filterGroup.id].includes(currentFilterValue.id);
  };

  removeNavigationFiltersAndSetCommonView = () => {
    const commonView = (this.props.windowWidth < 991) ? 4 : 3;
    if ((this.props.activeNavigationFilter === COUNTERTOP_WIZARD_BUTTONS[2].buttonId)
      && this.props.navigationViewType !== commonView) {
      this.props.setNavigationViewType(commonView);
    }
    this.props.setActiveNavigationFilter(null);
  };

  handleFilterValueClick = (currentFilterValue) => {
    // if (isActive) {
    //   return  // we don't need to do anything on active item click
    // }
    // console.log("currentFilterValue", currentFilterValue);
    switch (this.props.activeNavigationFilter) {
      case "inlay_type": {
        const modulePartJoined = this.props.moduleContextMenuModule + "_" + this.props.moduleContextMenuModulePart; //"2_3"
        let neededInlayTypesObject = this.props.activePart.inlayTypes.find(obj => obj.name === currentFilterValue.value);
        if (currentFilterValue.value !== this.props.activePart.defaultInlayType) {
          if (!neededInlayTypesObject) {
            neededInlayTypesObject = {name: currentFilterValue.value, moduleParts: []};  // create new & push
            this.props.activePart.inlayTypes.push(neededInlayTypesObject);
          }
          if (!neededInlayTypesObject.moduleParts.includes(modulePartJoined)) {
            neededInlayTypesObject.moduleParts.push(modulePartJoined);
            this.props.activePart.activeFeatureParts = this.props.activePart.setActiveFeatureParts();
            this.props.refreshCB();
          }
        } else {  // it is default type, we need to remove it from the not-default inlayTypes
          this.props.activePart.inlayTypes.forEach(inlayTypeObj => {
            const existingMJoinedIndex = inlayTypeObj.moduleParts.findIndex(mJoined => mJoined === modulePartJoined);
            if (existingMJoinedIndex > -1) {
              inlayTypeObj.moduleParts.splice(existingMJoinedIndex, 1);
              this.props.activePart.activeFeatureParts = this.props.activePart.setActiveFeatureParts();
              this.props.refreshCB();
            }
          });
        }
        this.forceUpdate(); // re-render to set new active item
        break;
      }
      case COUNTERTOP_WIZARD_BUTTONS[1].buttonId:
      case COUNTERTOP_WIZARD_BUTTONS[2].buttonId: {
        // this.props.setCountertopWizard({ // not needed for now, but probably we would need this logic in future
        //   [this.props.activeNavigationFilter] : currentFilterValue.id
        // });
        if (currentFilterValue.id === "All") {
          const selectedFilter = this.props.selectedFilters.find(selectedF => {
            return selectedF.filterGroupId === this.state.filterGroup.id
          });
          if (selectedFilter) { // should work always, but just in case
            this.props.setSelectedFilters(toggleFilterArrayValue([...this.props.selectedFilters], {
              filterId: selectedFilter.filterId,
              filterGroupId: this.state.filterGroup.id
            })); // remove selected filter
          }
          this.removeNavigationFiltersAndSetCommonView();
        } else if (Array.isArray(currentFilterValue.items) && currentFilterValue.items.length) {
          this.setParentFilterValues(currentFilterValue.items.map(fValue => fValue.id))
        } else {
          this.props.setSelectedFilters(replaceFilterArrayValue([...this.props.selectedFilters], {
            filterId: currentFilterValue.id,
            filterGroupId: this.state.filterGroup.id
          }));
          this.removeNavigationFiltersAndSetCommonView();
        }
        break;
      }
      default: {
        let matchingFeatures = this.props.activePart.features.filter((feature) => {
          return this.state.filterGroup && feature.dbFeature.filterValueIDs[this.state.filterGroup.id]
            && feature.dbFeature.filterValueIDs[this.state.filterGroup.id].includes(currentFilterValue.id)
        });
        if (this.props.activePart.partId === "top_cabinet" && this.props.activePart.activeFeature.metaData["Module"]) {
          const activeFeatureNameSplitted = this.props.activePart.activeFeature.partName.split(" M ");
          matchingFeatures = matchingFeatures.filter((feature) => {
            const featureNameSplitted = feature.partName.split(" M ");
            return (featureNameSplitted.length > 1) && (activeFeatureNameSplitted.length > 1)
              && featureNameSplitted[1] === activeFeatureNameSplitted[1]
          })
        } else if (this.props.activePart.partId === "bottom_cabinet" && this.props.activePart.activeFeature.metaData["Module"]) {
          matchingFeatures = matchingFeatures.filter((feature) => feature.metaData["Appliance"]
            && feature.metaData["Appliance"].includes("Range"))
        } else if (this.props.activePart.partId === "countertop" || this.props.activePart.partId === "center_island_countertop") {
          matchingFeatures = this.getMatchingFeaturesBySplittedName(matchingFeatures);
        }
        if (matchingFeatures.length) {
          this.props.onItemClick({part:matchingFeatures[0]}, true);
          this.forceUpdate(); // re-render to set new active item
        }
        break;
      }
    }

  };

  getMatchingFeaturesBySplittedName = (matchingFeatures = []) => {  // array of sorted by filter features
    let currentActiveName = this.props.activePart.activeFeature.partName;
    const filterGroupName = this.getFilterGroupNameByButtonId(this.props);
    const filterGroup = this.props.filterGroups.find(group => group.name === filterGroupName);
    if (filterGroup && filterGroup.values && filterGroup.values.length) {
      filterGroup.values.forEach((filterGroupValue) => { // arrayOf {id: 293, value: "Eased", displayText: "Eased", parent_id: null, icon: "", …}
        currentActiveName = currentActiveName.split(" "+filterGroupValue.value).join("");
      });
    }
    return matchingFeatures.filter(feature => {
      let featureName = feature.partName;
      filterGroup.values.forEach((filterGroupValue) => { // arrayOf {id: 293, value: "Eased", displayText: "Eased", parent_id: null, icon: "", …}
        featureName = featureName.split(" "+filterGroupValue.value).join("");
      });
      return featureName === currentActiveName
    })
  };

  getFilterFeatureItem = (filterValue, currentIndex, currentActiveFilters) => {
    const currentFilterValue = filterValue === "All"
      ? wizardAllButton
      : getAllFilterGroupValuesFromGroup(this.state.filterGroup).find(val => val.id === filterValue); // Object
    if (!currentFilterValue) {
      // console.log("NO filterValue!", filterValue, currentIndex, this.state.availableFilterValues);
      return;
    }
    let thumbnail = this.getFeatureBodyItemThumbnail(currentFilterValue);

    const styles = {
      backgroundSize: this.props.activeNavigationFilter === "color" ? "cover" : "inherit"
    };
    if (thumbnail) {
      styles.backgroundImage = "url(" + thumbnail + ")";
    }
    if (!thumbnail && currentFilterValue && this.props.activeNavigationFilter === "color") {
      styles.backgroundColor = currentFilterValue.value;
    }
    if (filterValue === "All") {
      styles.backgroundSize = (this.props.windowWidth < 991) ? "70%" : "50%";
      styles.backgroundPosition = "top 30% center";
    }
    const isActive = this.filterValueIsActive(currentActiveFilters, currentFilterValue);

    return this.props.isMobile ? (
      <li className="menu-list__item" key={"filterFeatureItem"+currentIndex}>
        <div className={"menu-list__item-feature" + (isActive ? " active" : "") + (filterValue === "All" ? " menu-list__item-feature--all" : "")
          // + (props.backGroundSizeCover ? " menu-list__item-feature--stone" : "")
          // + (props.disabled ? " menu-list__item-feature--not-available" : "")
        }
             onClick={() => this.handleFilterValueClick(currentFilterValue)}
             style={styles}>
          <div className="menu-list__item-feature-text">
            <span className="menu-list__item-feature-text-name">{currentFilterValue.displayText}</span>
          </div>
        </div>
      </li>
      ) : (
      <div className={"feature" + (isActive ? " active" : "") + (filterValue === "All" ? " feature--all" : "")}
           key={"loading-feature"+currentIndex}
           onClick={() => this.handleFilterValueClick(currentFilterValue)}
           style={styles}>
        <div className={"feature-text"}>
          <span className="feature-text__name">{currentFilterValue.displayText}</span>
        </div>
      </div>
    )
  };

  renderMobileFiltersList = () => {

    if (this.state.isLoading) {
      return this.renderLoadingList();
    }

    const currentActiveFilters = this.props.activePart.activeFeature
      ? this.props.activePart.activeFeature.dbFeature.filterValueIDs
      : {};

    if (!this.state.filterGroup || !this.state.filterGroup.values) {
      return [];
    }

    return this.state.availableFilterValues.map((filterValue, filterValueIndex) => {
      return this.getFilterFeatureItem(filterValue, filterValueIndex, currentActiveFilters)
    })
  };

  renderFiltersList = () => {

    const currentActiveFilters = this.props.activePart.activeFeature
      ? this.props.activePart.activeFeature.dbFeature.filterValueIDs
      : {};

    const navigationViewType = this.props.navigationViewType === 3 ? 2 : 1;
    const elements = [];
    for (let i = 0; i <= Math.ceil(this.state.availableFilterValues.length - 1 / navigationViewType); i++ ) {  // for ex. 28/3 = 10 columns
      const innerElements = [];
      for (let j = 0; j < navigationViewType;j++ ) {
        const currentIndex = j+(i*navigationViewType);
        // console.log("currentIndex", currentIndex);
        const filterValue = this.state.availableFilterValues[currentIndex]; // Number, for example 1031
        if (!this.state.filterGroup || !this.state.filterGroup.values) {
          break;
        }
        innerElements.push(this.getFilterFeatureItem(filterValue, currentIndex, currentActiveFilters));
      }
      elements.push(
        <li className="features-list__item" key={"features-list__item"+i}>
          {innerElements}
        </li>
      );
    }

    return elements
  };

  renderLoadingList() {
    return <div className="message-loading-left-panel-spinner message-loading-left-panel-spinner--small"/>
  }

  render() {
    return this.props.isMobile ? this.renderMobileFiltersList() : (
      <ul className={"categories-list categories-list--"+ this.props.navigationViewType}>
        {this.state.isLoading ? this.renderLoadingList() : this.renderFiltersList()}
      </ul>
    )
  }
}

const mapStateToProps = (store) => {
  return {
    filterGroups: store.filterState.filterGroups,
    fabricatorData: store.fabricatorState,
    activeNavigationFilter: store.navigationState.activeNavigationFilter,
    moduleContextMenuModule: store.navigationState.moduleContextMenuModule,
    moduleContextMenuModulePart: store.navigationState.moduleContextMenuModulePart,
    counterTopWizard: store.navigationState.counterTopWizard,
    navigationViewType: store.navigationState.navigationViewType,
    selectedFilters: store.filterState.selectedFilters,
    availableFilterValues: store.filterState.availableFilterValues,
    windowWidth: store.serverState.windowWidth,
  };
};

export default connect(mapStateToProps, {
  setCountertopWizard,
  setSelectedFilters,
  setActiveNavigationFilter,
  setActiveNavigationFilterStepIndex,
  setNavigationViewType,
  setAvailableFilterValues,
})(NavigationFilters);
